import React, { useState,useContext,createContext,useReducer } from 'react'
import { cartReducer } from './Reducers';

const INITIAL_STATE = {
    cart:[],
    carType: {
        ADD_TO_CART: "ADD_TO_CART",
        REMOVE_ITEM: "REMOVE_ITEM",
        INCREASE: "INCREASE",
        DECREASE: "DECREASE",
        CHECKOUT: "CHECKOUT",
        CLEAR: "CLEAR",
    }
}
const Cart = createContext();
const Context = ({children}) => {
const [state,dispatch] = useReducer(cartReducer,INITIAL_STATE);
  return (
    <Cart.Provider value={{state,dispatch}}>
      {children}
    </Cart.Provider>
  )
}

export default Context
export const CartState = () => 
{
    return useContext(Cart);
}


// second context 
export const UserContext = createContext();
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    setUser(null);
  };

  return (
    <UserContext.Provider value={{ user, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
